function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "15"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-3-3h20v20H-3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#acacac",
  d: "M0 11.877v3.125h3.125l9.217-9.217L9.217 2.66 0 11.877zM14.758 3.37a.83.83 0 000-1.175l-1.95-1.95a.83.83 0 00-1.175 0L10.108 1.77l3.125 3.125 1.525-1.525z"
}))));